import { UserDetailsResponse } from "../../../@types/Users";
import { api } from "../../api";

export default async function getDetails(): Promise<UserDetailsResponse | null> {
  try {
    const { data } = await api.get("/user");

    return data as UserDetailsResponse;
  } catch (err) {
    console.log(err);

    return null;
  }
}
